export const driverCardText = {
	onProtection: 'On protection',
	arrivesToHomeBase: 'Arrives to home base',
	departsHomeBase: 'Departs home base',
	doingHolddown: 'Doing holddown',
	homeBase: 'Home base:',
	arrivedAtLocation: 'Arrived at location:',
	expectedPresence: 'Expected presence:',
	preAssignmentIdleTime: 'Pre-assignment idle time',
	timeToFresh: 'Time to fresh:',
	restNotNeeded: 'Rest not needed',
	estDrivingCapacity: 'Est. Driving Capacity:',
	workingCapacity: 'Working Capacity:',
	eligibilityIssues: 'Eligibility issues',
	assign: 'Assign',
	viewProfile: 'View Profile',
};
